import { render } from "./CreateAnnouncementDialog.vue?vue&type=template&id=2b757dc2&scoped=true"
import script from "./CreateAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncementDialog.vue?vue&type=script&lang=js"

import "./CreateAnnouncementDialog.vue?vue&type=style&index=0&id=2b757dc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b757dc2"]])

export default __exports__